import React, { useState } from 'react';
import withAppState from '../../../mobx/withAppState'
import TablePicker from '../../../components/TablePicker';
import assignSplits from '../common/AssignSplits';
import { Steps } from '../../../lib/constants';

const MiPayAtTableTablePickerWrapper = (props) => {
  const [loading, setLoading] = useState(false);

  const pressEnterKey = async (tableNumber) => {
    const { restaurant: { id: restaurantId }, splitBillSessionToken, customer } = props;
    if (tableNumber > 0) {
      setLoading(true);
      const response = await fetch(
        `api/Bill/Lookup/${restaurantId}/${tableNumber}`
      )

      if (response.status !== 200) {
        props.setErrorModalMessage(
          `Sorry, we could not find a table ${tableNumber}.`
        );
        setLoading(false);
        return;
      }

      let data;
      try {
        data = await response.json();
      } catch (err) {
        setLoading(false);
        return;
      }

      props.selectTableNumber(tableNumber);

      const { bills, success } = data;
      const bill = bills[0];

      if (success !== true || !bill) {
        props.setErrorModalMessage(
          `Sorry, we could not find a table ${tableNumber}.`
        );
        setLoading(false);
        return;
      }

      setLoading(false)
      props.setBill(bills);
      props.goToStep(Steps.BILL);
      assignSplits(props, bill, customer, splitBillSessionToken);
    }
  }

  return <TablePicker pressEnterKey={pressEnterKey} setLoading={setLoading} loading={loading} />
}

export default withAppState(MiPayAtTableTablePickerWrapper,
  {
    mobXProps: ({
      restaurant,
      bill,
      customer,
      splitBillSessionToken,
    }) => ({
      restaurant,
      bill,
      customer,
      splitBillSessionToken,
    }),
    mobXActions: ({
      goToStep,
      setErrorModalMessage,
      setSelectedSplitIndex,
      setAssignedSplitIndex,
      setBill,
      selectTableNumber,
      getCurrency
    }) => ({
      goToStep,
      setErrorModalMessage,
      setSelectedSplitIndex,
      setAssignedSplitIndex,
      setBill,
      selectTableNumber,
      getCurrency
    })
  }
);